// extracted by mini-css-extract-plugin
export default {"footer":"layout-footer_footer__QxBo3","footerCondition":"layout-footer_footerCondition__zZ27c"};